import { PILL_TYPE_ENUM, WcgPillType } from '@wcg/frontend-framework';
import { DryRunParamControlKind } from '../types/remediation-dry-run-panel.types';

export const DRY_RUN_PARAM_CONTROL_KIND_BY_TYPE: Record<
  string,
  DryRunParamControlKind
> = {
  int: 'number',
  float: 'number',
  number: 'number',
  bool: 'checkbox',
  boolean: 'checkbox',
  date: 'date',
  datetime: 'datetime',
  email: 'email',
  list: 'list',
};

export const DRY_RUN_NUMERIC_PARAM_TYPES = ['int', 'float', 'number'];

export const DRY_RUN_PREVIEW_NOTE =
  'Point-in-time preview. Results may differ at Execute.';

export const DRY_RUN_EMPTY_RESULT_MESSAGE =
  'No records currently meet the criteria for this action.';

export const DRY_RUN_BLOCKED_FALLBACK_MESSAGE =
  'A dry run is not available for this request right now.';

export const DRY_RUN_BLOCKED_MESSAGES: Record<string, string> = {
  WindowClosed:
    'This approval has expired. Submit a new request to run this script.',
  RequestExpired: 'The request expired before it was approved.',
  RequestNotActive: 'This request was rejected or withdrawn.',
  ActionDisabled: 'The remediation action is not active.',
  NotRequesterOrApprover:
    'Only the requester or an approver can run a dry run.',
  Impersonating: 'Dry runs cannot be run while impersonating.',
};

export const EXECUTE_BLOCKED_FALLBACK_MESSAGE =
  'This request cannot be run right now.';

export const EXECUTE_BLOCKED_MESSAGES: Record<string, string> = {
  ...DRY_RUN_BLOCKED_MESSAGES,
  RequestNotApproved: 'This request has not been approved yet.',
  NotRequester: 'Only the requester can run this script.',
};

export const REMEDIATION_RUN_RESULT_PILL_TYPES = new Map<string, WcgPillType>([
  ['Succeeded', PILL_TYPE_ENUM.SUCCESS],
  ['Failed', PILL_TYPE_ENUM.ERROR],
  ['Prepared', PILL_TYPE_ENUM.INFO],
]);

export const EXECUTE_ALL_OR_NOTHING_NOTE =
  'A run is all or nothing. If it fails, none of these changes are kept.';

export const HTTP_STATUS_TEXTS: Record<number, string> = {
  0: 'Network Error',
  200: 'OK',
  400: 'Bad Request',
  401: 'Unauthorized',
  403: 'Forbidden',
  404: 'Not Found',
  409: 'Conflict',
  422: 'Unprocessable Entity',
  500: 'Internal Server Error',
  502: 'Bad Gateway',
  503: 'Service Unavailable',
  504: 'Gateway Timeout',
};
